import { apiFilters } from '@spo/services/api';
import {
  SpoAvailableFiltersResponse,
  SpoUserSettingsResponse,
} from '@spo/types';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useUserConfig } from './useUserConfig';

export type UseAvailableFiltersProps = {
  userConfig: SpoUserSettingsResponse | undefined;
};

export const useAvailableFilters = () => {
  const { data: userConfig } = useUserConfig();
  const [availableFilters, setAvailableFilters] =
    useState<SpoAvailableFiltersResponse>({
      productManager: [],
      productNature: [],
      retailFamily: [],
      userSegmentation: [],
      sports: [],
      status: [],
    });

  const useQueryData = useQuery({
    queryKey: ['useAvailableFilters', userConfig],
    queryFn: async ({ signal }) => {
      if (
        userConfig &&
        userConfig.offerDate &&
        userConfig.productNatureIds &&
        userConfig.retailFamilyIds &&
        userConfig.sportIds &&
        !signal?.aborted
      ) {
        return await apiFilters.getAvailableFilters(userConfig);
      }
    },
    enabled: !!userConfig && !userConfig?.needRedirect,
  });

  return {
    allFilters: useQueryData.data,
    availableFilters,
    setAvailableFilters,
  };
};
